// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"815e7a18","210":"bcb8ac3b","320":"b4c9ea9a","504":"7689b63b","517":"eaa30571","558":"94149dbf","629":"0f9bc978","669":"6be0c67d","847":"da713023","967":"b3796940"}[chunkId] + ".chunk.js";
};